import React from "react";
import {connect} from "react-redux";
import LoadingBar from '../../../lib/react-redux-loading-bar';


const MaterialsMainLoading = (props) => {

  const {visualizerNotAvailable, materialsCanvasLoading} = props;

  if (visualizerNotAvailable || !materialsCanvasLoading) {
     return null
  }

  return (
    <div className="selection-overlay">
      <div className="selection-overlay__loader">
        <div className="message-loading-left-panel message-loading-panel-settings">
          <div className="message-loading-left-panel-spinner"/>
          <LoadingBar className="message-loading-left-panel-counter"/>
        </div>
      </div>
    </div>
  )

};

const mapStateToProps = (store) => {
  const {materialsCanvasLoading} = store.selectionState;
  const {visualizerNotAvailable} = store.initialFlowState;

  return {
    visualizerNotAvailable,
    materialsCanvasLoading,
  };
};

export default connect(mapStateToProps)(MaterialsMainLoading)
